module.exports = new __parcel__URL__("paintbucket-icon.b20c801a.jpg").toString();